module.exports = __webpack_public_path__ + "79bf7b5619f3edf1636ec04a43191f1c.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/error-robot.png
// module id = 254
// module chunks = 1